import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import "./Forgot.css";

import apiRequest from '../../../api';

const ForgotPassword = () => {
  const validationSchema = Yup.object({
    email: Yup.string()
    //.email("Invalid email address")
    //.required("Email is required"),
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return localStorage.getItem('Language') || 'EN';
  });
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen);
  useEffect(() => {
    localStorage.setItem('Language', selectedLanguage);
  }, [selectedLanguage]);
  const handleSubmit = async (value, { resetForm }) => {

    const requestBody = {
      email: value.email,
    };

    // Make the POST request
    try {
      const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
      const response = await apiRequest('/api/users/get_password', 'POST', requestBody, token);
      if(selectedLanguage === 'EN')
        setSuccessMessage("Mail was sent!");
      else
        setSuccessMessage("Mejl je poslat!");
      resetForm();
    } catch (error) {
      //console.error("Error creating lot:", error);
      try {
        // Parse the error message
        const errorData = JSON.parse(error.message);

        // Check if the body contains the error and starts with the desired text
        if (errorData.Body?.error?.startsWith("User with email")) {
          if (selectedLanguage === 'EN')
            setSuccessMessage("User with that email address doesn't exist");
          else
            setSuccessMessage("Korisnik sa datom email adresu ne postoji");
        } else {
          setSuccessMessage("");
        }
      } catch (parseError) {
        alert("Error: " + error);
        setSuccessMessage("");
      }

    }
  };

  return (
    <div className="login-page">
      <div className="login-overlay">
        <div className="login-card-forgot">
          <div className="login-logo">
            <img
              src="/assets/img/FORUM26_white.png"
              alt="Logo"
              className="logo-image"
            />
          </div>
          <Formik
            initialValues={{
              email: "",
            }}

            onSubmit={handleSubmit}
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit} className="login-form">
                <FormGroup className="mb-4 position-relative">
                  <Field
                    as={Input}
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="ps-5 text-start"
                  />
                  <img
                    src="assets/icons/email.svg"
                    width={25}
                    alt="email"
                    className="input-icon"
                  />
                  <label className="invalid-feedback"></label>
                </FormGroup>
                {successMessage && (
                  <div className="mb-3"
                    style={{
                      fontSize: "16px",
                      fontFamily: "jura-light",       // Text color
                      textAlign: "center",  // Centers the text horizontally
                    }}>
                    {successMessage}
                  </div>
                )}
                <Button color="primary" block type="submit" className="login-button">
                  {selectedLanguage === "EN" ? "Forgot Password" : "Pošalji"}
                </Button>
 
                <div className="forgot-password">
                  <Link className="forgot-link" to="/login">
                    {selectedLanguage === "EN" ? "Back to login" : "Povratak na login stranu"}
                  </Link>                  
                </div>
              </Form>
            )}
           
          </Formik>
        </div>
      </div>
      <Dropdown
        isOpen={languageDropdownOpen}
        toggle={toggleLanguageDropdown}
        className="language-dropdown"
        style={{
          position: "fixed",
          bottom: "10px",
          right: "10px",
          zindex: "1000"
        }}
      >
        <DropdownToggle caret className="lang-toggle">
          {selectedLanguage}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => setSelectedLanguage('EN')}>EN</DropdownItem>
          <DropdownItem onClick={() => setSelectedLanguage('RS')}>RS</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

export default ForgotPassword;
